//@flow
import * as React from 'react'
import { connect } from 'react-redux';
import { reduxForm,formValueSelector,submit,change } from 'redux-form';
import MaterialPaperWrap from '../../components/common/MaterialPaperWrap'
import InvoiceHeaderForm from './InvoiceHeaderForm'
import ContainerRowActionDialog from '../../components/common/ContainerRowActionDialog'
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import NemesisQualityReview from './NemesisQualityReview'
import ContainerRowError from '../../components/common/ContainerRowError'
import { validate,getQualityReviewFormNoOfError } from './validate'
import * as actions from '../../redux/nemesis/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import collect from 'collect.js'
import type { InvoiceHeaderContainer$Props } from './flowTypes'

const InvoiceHeaderContainer=(props:InvoiceHeaderContainer$Props)=>{
    const formError = props.nemesis.formError
    const noOfErrorsInQualityReview = getQualityReviewFormNoOfError(props,collect(formError))
   
    return (
        <div className='row'>
            <div className='col-sm'>
                <MaterialPaperWrap>
                   <form onSubmit={props.handleSubmit} > 
                     <div className='container'>
                        <div className="row">
                            <div className="col-sm">
                                <div className="embed-responsive embed-responsive-1by1" style={{height: '100%'}}>
                                  <iframe className="embed-responsive-item" src={props.query.docUrl}></iframe>
                                </div>
                            </div>
                            <div className="col-sm">
                                <InvoiceHeaderForm 
                                jwt={props.query.jwt} isVerifyMode={props.query.isVerifyMode} 
                                taskAcceptedInfoId={props.query.taskAcceptedInfoId} 
                                {...props}
                                />
                            </div>
                        </div>
                        <ContainerRowError errorMsg={(props.nemesis.error:any)} />
                        <ContainerRowSpace />
                        <NemesisQualityReview demeter={props.nemesis} noOfErros={noOfErrorsInQualityReview} {...props}/>
                        <ContainerRowActionDialog 
                            title={'Invoice Data Extraction'}
                            message={'Please do double check and confirm all your inputs before click submit.'}
                            submitFunc={props.submitReduxForm}
                        />

                        <ContainerRowSpace />
                     </div>   
                  </form>   
                </MaterialPaperWrap>
            </div>
        </div>
    )    
}

const form='nemesisInvoiceHeaderContainer'
const selector = formValueSelector(form)

const submitMethod = (values, dispatch, props) => {
    const { nemesis } = props;
    const { jwt,taskAcceptedInfoId } = props.query
    props.submitCloseActionDialog()
    props.invoiceSubmission(jwt,taskAcceptedInfoId,values,nemesis);
}

const InvoiceHeaderContainerReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submitMethod
})(InvoiceHeaderContainer)

const mapStateToProps:any = (state, ownProps) => {
    return {
        nemesis: state.nemesis,
        initialValues: state.nemesis.formData,
        selector: selector,
        actConfDialog: state.actConfDialog
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      invoiceSubmission: (jwt,taskAcceptedInfoId,nemesisResultset,nemesis) => {
        dispatch(actions.invoiceSubmission(jwt,taskAcceptedInfoId,nemesisResultset,nemesis))  
      },
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
      submitCloseActionDialog: ()=> {
        dispatch(actConfDlgActions.closeDialog())    
      },
      submitReduxForm: ()=>{
        dispatch(submit(form))
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      },
      updateFormError: (error:any)=>{
        dispatch(actions.updateFormError(error))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderContainerReduxForm)


// WEBPACK FOOTER //
// ./src/views/ProjectNemesis/InvoiceHeaderContainer.js